module.exports = __webpack_public_path__ + "static/img/sharing_116.df87b53.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sharing/sharing_116.jpg
// module id = O26E
// module chunks = 2